import { render, staticRenderFns } from "./jin-lian.vue?vue&type=template&id=7d4e200a&scoped=true"
import script from "./jin-lian.vue?vue&type=script&lang=js"
export * from "./jin-lian.vue?vue&type=script&lang=js"
import style0 from "./jin-lian.vue?vue&type=style&index=0&id=7d4e200a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4e200a",
  null
  
)

export default component.exports